/**
 * help-menu.js
 */

import React from 'react';
import { Chip, Divider, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { forceShowIntercomLauncherIfIntercomOpen } from 'utils/misc';
import { AppUtilityContext } from 'contexts/app-utility/app-utility-context';
import { LiveTrackingContext } from 'components/tracking/live-tracking/live-tracking-context';
import Icon from 'components/icon';
import DropMenu from 'components/drop-menu';
import useTours from 'components/tour/tour-data';
import ConfirmDialog from 'components/confirm-dialog';
import BarButton from '../bar-button';


const useStyles = makeStyles(theme => ({
  helpMenu: {
    borderRadius: '16px',
  },
  recommendedChip: {
    backgroundColor: theme.palette.sys.surfaceContainerHighest,
    color: theme.palette.sys.onSurface,
    marginLeft: theme.spacing(1.5),
  },
}));



export default function HelpMenu(props) {
  const {
    label,
    onSelect,
    isInMobileContext,
  } = props;
  const classes = useStyles();
  const { alertError } = React.useContext(AppUtilityContext);
  const { isActive: isTrackingActive } = React.useContext(LiveTrackingContext);
  const { startTour, resetAllTours } = useTours();
  const [confirmRestart, setConfirmRestart] = React.useState();


  const helpMenuItems = React.useMemo(() => [
    {
      key: 'getSupport',
      name: <>Support Chat <Chip label='Recommended' size='small' className={classes.recommendedChip} /></>,
      icon: 'support',
      path: null,
      onSelect: () => {
        window.Intercom('showNewMessage');
        setTimeout(() => {
          if (isInMobileContext) {
            forceShowIntercomLauncherIfIntercomOpen();
          }
        }, 500);
      }
    },
    ...(isInMobileContext ? [] : [{
      key: 'emailSupport',
      name: 'Send Email to Support',
      icon: 'email',
      endIcon: 'open-in-tab',
      onSelect: () => {
        window.open('mailto:support@mypacktrack.com', '_blank');
      }
    }]),
    {
      key: 'knowledgeBase',
      name: 'Knowledge Base',
      icon: 'info',
      // endIcon: 'open-in-tab',
      onSelect: () => {
        if (isTrackingActive) {
          alertError({
            title: 'Action Unavailable',
            text: `This action isn't allowed because you're currently creating a location track. To use this function, first return to the tracking interface and finish your active track.`
          });
          return;
        }
        window.open('https://intercom.help/packtrack/en/collections/3754752-knowledge-base', '_self');
      }
    },
    ...(isInMobileContext ? [] : [{
      key: 'divider',
      name: <Divider />,
      disabled: true
    }]),
    ...(isInMobileContext ? [] : [{
      key: 'restartTours',
      name: 'Restart Product Tours ...',
      icon: 'lightning',
      onSelect: async () => {
        if (await confirmRestart()) {
          resetAllTours();
        }
      }
    }]),
  ], [classes, isInMobileContext, isTrackingActive, alertError, confirmRestart, resetAllTours]);


  const handleMenuSelect = (menuItem) => {
    if (Number.isInteger(menuItem.key)) {
      startTour(menuItem.key);
    }
    if (onSelect) {
      onSelect();
    }
  }


  return (
    <>
      <DropMenu
        id="change-role"
        label={label ?? (
          <Tooltip
            arrow
            placement='bottom'
            title='Get Help'
          >
            <span style={{ display: 'inline-block' }}>
              <BarButton>
                <Icon type='help' className={classes.helpMenu} />
              </BarButton>
            </span>
          </Tooltip>
        )}
        aria-label="change role menu"
        onSelect={handleMenuSelect}
        items={helpMenuItems}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      />

      <ConfirmDialog
        title="Restart Product Tours"
        content={`Product tours look like glowing yellow circles. They provide helpful information on how PACKTRACK works.
          Click the RESTART button to show all available tours even if you've seen them before.`}
        titleStyle="warning"
        titleIcon="warning"
        setConfirm={setConfirmRestart}
        customActions={[
          {
            label: 'Cancel',
            value: false,
            isNotPriority: true,
          },
          {
            label: 'Restart',
            value: true,
          }
        ]}
      />

    </>
  );
}